/*
**************************************************************************
Title:          User model
Created By:     Pankaj Arora
Created on:     05/04/2018
Description:    Format the model for users
                A User represents an agent that sends messages. Bot or Current user
**************************************************************************
*/
import { uuid } from '../../utils';

export class User {
  id: string;

  constructor(public name: string) {
    this.id = uuid(); // unique ID
  }
}
